(() => {
  const registry = window.__yiosi03Registry || (window.__yiosi03Registry = new WeakSet());
  const init = (scope = document) => scope.querySelectorAll('[data-yiosi-catalog]').forEach(root => {
    if (registry.has(root)) return;
    registry.add(root);
    const dialog = root.querySelector('dialog');
    const sort = value => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    };
    root.querySelector('[data-sort-select]')?.addEventListener('change', event => sort(event.target.value));
    root.querySelectorAll('[data-sort-link]').forEach(link => {
      // Real href also retains filters for no-JS navigation and open-in-new-tab.
      const target = new URL(window.location.href);
      target.searchParams.set('sort_by', link.dataset.sortLink);
      target.searchParams.delete('page');
      link.href = target.toString();
    });
    const more = root.querySelector('[data-infinite-next]');
    const grid = root.querySelector('.grid');
    if (more && grid && 'IntersectionObserver' in window) {
      // Infinite scroll: numbered pages stay in the HTML for no-JS and crawlers, hidden here.
      const pages = root.querySelector('.pagination');
      if (pages) pages.hidden = true;
      more.hidden = false;
      let loading = false;
      const stop = () => { observer.disconnect(); more.remove(); };
      const observer = new IntersectionObserver(async entries => {
        if (loading || !entries.some(entry => entry.isIntersecting)) return;
        loading = true;
        more.textContent = 'Loading more pieces…';
        try {
          const url = new URL(more.dataset.infiniteNext, window.location.origin);
          url.searchParams.set('section_id', root.dataset.sectionId);
          const response = await fetch(url);
          if (!response.ok) throw new Error(response.status);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          html.querySelectorAll('.grid > :not(.empty)').forEach(card => grid.appendChild(card));
          const next = html.querySelector('[data-infinite-next]');
          more.textContent = '';
          loading = false;
          if (!next) return stop();
          more.dataset.infiniteNext = next.dataset.infiniteNext;
          observer.unobserve(more); observer.observe(more); // Re-check: a tall screen may still need more.
        } catch (error) {
          console.error(error);
          if (pages) pages.hidden = false;
          stop();
        }
      }, {rootMargin: '0px 0px 1000px 0px'});
      observer.observe(more);
    }
    if (!dialog) return;
    let opener;
    const form = dialog.querySelector('form');
    const min = form.querySelector('[data-price-min]');
    const max = form.querySelector('[data-price-max]');
    const error = form.querySelector('[data-price-error]');
    const sync = () => form.querySelectorAll('[data-price]').forEach(button => {
      const pair = button.dataset.price === 'all' ? ['', ''] : button.dataset.price.split(',');
      const selected = (min?.value || '') === pair[0] && (max?.value || '') === pair[1];
      button.classList.toggle('selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    const close = () => dialog.close();
    root.querySelectorAll('[data-open-filter]').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', () => {
        opener = button;
        form.reset(); // Reopen with applied values, discard unapplied edits.
        if (error) error.textContent = '';
        form.querySelectorAll('details').forEach(item => item.open = false);
        sync();
        dialog.showModal();
        document.body.classList.add('drawer-open');
      });
    });
    dialog.querySelector('[data-close-filter]')?.addEventListener('click', close);
    dialog.addEventListener('close', () => {
      document.body.classList.remove('drawer-open');
      if (opener?.isConnected) opener.focus();
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    form.addEventListener('input', () => { if (error) error.textContent = ''; sync(); });
    form.querySelectorAll('[data-price]').forEach(button => button.addEventListener('click', () => {
      if (!min || !max) return;
      const pair = button.dataset.price === 'all' ? ['', ''] : button.dataset.price.split(',');
      min.value = pair[0]; max.value = pair[1];
      if (error) error.textContent = '';
      sync();
    }));
    form.addEventListener('submit', event => {
      const invalid = [min, max].some(input => input && input.value !== '' && (!Number.isFinite(Number(input.value)) || Number(input.value) < 0));
      if (invalid || (min && max && min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value))) {
        event.preventDefault();
        if (error) error.textContent = 'Enter a valid price range. Maximum must be at least minimum.';
        const details = min?.closest('details'); if (details) details.open = true;
        min?.focus();
        return;
      }
      // Omit empty bounds, preventing accidental zero-price filtering.
      [min, max].forEach(input => { if (input && input.value === '') input.disabled = true; });
    });
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
